import { useApi } from '../composables/useApi'
import { URLS } from '../constants/urls'

export default function relatorioCaptacaoService() {
	const api = useApi()

	async function getTopBottomSai(query = '') {
		return api.query(`${window.origin}${URLS.top_bottom_sai}${query}`)
	}

	async function getTopBottomSap(query = '') {
		return await api.query(`${window.origin}${URLS.top_bottom_sap}${query}`)
	}

	async function getRelatorioPoliticaAgendamento(params) {
		return await api.query(URLS.relatorio_politica_agendamento, params)
	}

	return {
		getTopBottomSai,
		getTopBottomSap,
		getRelatorioPoliticaAgendamento,
		...api,
	}
}
